/**
 * Tabulation - Represents tabulation information for organizing and categorizing contract items.
 * Used to structure pay items by class, category, group, and sheet numbers.
 */
export class Tabulation {
  /** Classification number */
  Class: number;

  /** Category identifier */
  Category: string;

  /** Group identifier */
  Group: string;

  /** Code identifier */
  Code: string;

  /** Unique identifier */
  ID: string;

  /** Title or description */
  Title: string;

  /** Sheet number */
  SheetNum: number;

  /**
   * Creates a new Tabulation instance
   * @param data - Object containing tabulation properties
   */
  constructor(data: {
    Class: number;
    Category: string;
    Group: string;
    Code: string;
    ID: string;
    Title: string;
    SheetNum: number;
  }) {
    this.Class = data.Class;
    this.Category = data.Category;
    this.Group = data.Group;
    this.Code = data.Code;
    this.ID = data.ID;
    this.Title = data.Title;
    this.SheetNum = data.SheetNum;
  }

  /**
   * Creates a Tabulation from a plain object (useful for deserialization)
   * @param obj - Plain object with tabulation data
   * @returns New Tabulation instance
   */
  static fromObject(obj: Partial<Tabulation>): Tabulation {
    return new Tabulation({
      Class: obj.Class ?? 0,
      Category: obj.Category ?? "",
      Group: obj.Group ?? "",
      Code: obj.Code ?? "",
      ID: obj.ID ?? "",
      Title: obj.Title ?? "",
      SheetNum: obj.SheetNum ?? 0,
    });
  }

  /**
   * Converts the Tabulation to a plain object (useful for serialization)
   * @returns Plain object representation
   */
  toObject(): Record<string, unknown> {
    return {
      Class: this.Class,
      Category: this.Category,
      Group: this.Group,
      Code: this.Code,
      ID: this.ID,
      Title: this.Title,
      SheetNum: this.SheetNum,
    };
  }
}


